import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HistoricoIdssChartComponent } from './historico-idss-chart.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HistoricoIdssChartComponent],
  exports: [HistoricoIdssChartComponent],
})
export class HistoricoIdssChartChartModule {}
